import { useAllContactedAndSaved, SupplierWithEnquiryMessagingType } from "@queries/useAllContactedAndSaved";
import { UseQueryResult } from "@tanstack/react-query";

type MessagingStatusResult = UseQueryResult<SupplierWithEnquiryMessagingType[]> & {
    supplier: SupplierWithEnquiryMessagingType | undefined;
    enquiryState: 'not-contacted' | 'legacy' | 'contacted' | undefined;
    messageDate: string | undefined;
};

const useMessagingStatus = (
    supplierId: number,
    categoryId: number,
    options?: {
        enabled?: boolean;
    }
): MessagingStatusResult => {
    const { data, ...rest } = useAllContactedAndSaved(categoryId, false, true, {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        ...options,
    });
    const supplier = data?.find((supplier) => supplier.supplierId === supplierId);
    return {
        supplier,
        enquiryState: supplier?.enquiryState,
        messageDate: supplier?.enquiryMessage?.lastMessageDate,
        ...rest
    } as MessagingStatusResult;
}

export default useMessagingStatus;